<template>
  <div class="page">
    <div class="group_1">
      <div class="header">
        <span class="text_1">班级名称</span><span class="text_2">操作</span>
      </div>
         
      
      <div class="box_1">
        <div v-for="item in studtyList" :key="item.ID">
          <div class="li">
            <span style="width: 70%; color: #999; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">{{
              item.CLASS_NAME
            }}</span>
            <span style="width: 30%; text-align: center; color: #2a70f2" @click="gotoStudyzm(item)">查看</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { mapState } from 'vuex';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    return {
      // trainCertList:[]
    };
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapState('m_user', ['studtyList'])
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    gotoStudyzm(item){
       this.$router.push({
        path: '/classHour',
        query: { CLASS_ID: item.CLASS_ID,USER_ID:item.USER_ID }
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.page {
  background-color: #f6f8fa;
  height: 100vh;
  overflow-y: scroll;
}
.group_1 {

}
.header {
  border-bottom: 1px solid #f5f6f7;
  background-color: #fff;
  display: flex;align-items: center;
  width: 100%;padding: 0 10px;
  height: 40px;
  .text_1 {
    width: 70%;
    text-align: center;
  }
  .text_2 {
    width: 30%;
    text-align: center;
  }
}
.box_1 {
  background-color: #fff;
  width: 100%;
  .li {
  padding:0 10px;

    width: 100%;
    display: flex;align-items: center;
  border-bottom: 1px solid #f5f6f7;
height: 60px;
  }
}
</style>
